import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default () => ({
  path: ":subjectId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
